import { UserAuthToken } from '@sonar-software/sonar-security';

import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetImpersonateStopRequest = {
	shardName?: string;
};

export const getImpersonateStop = createGetEndpoint<GetImpersonateStopRequest, UserAuthToken>(
	'/api/v3/security/authentication/impersonate/stop',
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
